document.addEventListener('DOMContentLoaded', initShippingCalculator);

function initShippingCalculator() {
    if (Shopify && 'Cart' in Shopify && 'ShippingCalculator' in Shopify.Cart) {
        Shopify.Cart.ShippingCalculator.show({
            submitButton: shipping_calculator_labels.shippingCalcSubmitButton,
            submitButtonDisabled: shipping_calculator_labels.shippingCalcSubmitButtonDisabled,
            customerIsLoggedIn: shipping_calculator_labels.shippingCalcCustomerIsLoggedIn,
            moneyFormat: shipping_calculator_labels.shippingCalcMoneyFormat
        });
    }
}
